import Vue from 'vue'
import Router from 'vue-router'
import Overview from "./Overview";

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'overview',
      component: Overview
    },
    {
      path: '/account',
      name: 'account',
      component: () => import(/* webpackChunkName: "account" */ './Account.vue')
    },
    {
      path: '/device',
      name: 'devices',
      component: () => import(/* webpackChunkName: "devices" */ './Devices.vue')
    },
    {
      path: '/billing',
      name: 'billing',
      component: () => import(/* webpackChunkName: "billing" */ './Billing.vue')
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import(/* webpackChunkName: "billing" */ './Admin.vue')
    }
  ]
})
